import React from "react";
import styles from "./EventTimeline.module.scss";
import lemonYellowIcon from "../../img/eventTimeline/lemonYellowIcon.png";
import skyBlueIcon from "../../img/eventTimeline/skyBlueIcon.png";
import rocket from "../../img/eventTimeline/rocket.png";
import calendarIcon from "../../img/eventTimeline/calendar.png";
import pangIcon from "../../img/eventTimeline/pang.png";
const EventTimeline = ({ eventTimeLineRef }) => {
  return (
    <div className={styles.container} ref={eventTimeLineRef}>
      <div className={styles.contents_box}>
        <h1
          className={styles.event_timeline_title}
          data-content="Event Timeline"
        >
          Event Timeline
        </h1>
        <div className={styles.info_box}>
          <div className={styles.open_date_box}>
            <img className={styles.rocket} src={rocket} alt="rocket" />
            <span className={styles.open_date_text_box}>
              <p>Registration Open</p>
              <p>May 29</p>
            </span>
          </div>
          <div className={styles.sumbit_deadline_box}>
            <img
              className={styles.calendar}
              src={calendarIcon}
              alt="calendar"
            />
            <span className={styles.sumbit_deadline_text_box}>
              <p>Submissions Deadline</p>
              <p>July 7</p>
              <p>(11:59 PM UTC +0)</p>
            </span>
          </div>
          <div className={styles.closing_ceremony_box}>
            <img className={styles.pang} src={pangIcon} alt="pang" />
            <span className={styles.closing_ceremony_text_box}>
              <p>Closing Ceremony</p>
              <p>July 21</p>
            </span>
          </div>
          <img
            className={styles.lemon_yellow}
            src={lemonYellowIcon}
            alt="icon"
          />
          <img className={styles.sky_blue} src={skyBlueIcon} alt="icon" />
        </div>
        <a
          className={styles.dashboard_btn}
          href="https://dashboard.mondayoff.me"
          target="_blank"
          rel="noreferrer"
        >
          Join Now
        </a>
      </div>
    </div>
  );
};

export default EventTimeline;
